import { AttributesMixin, define, Model, type } from "@type-r/models";
import { restfulIO } from "api/endpoint";
import { AutoReconciledPaymentsState } from "../payments-ras/review/auto-reconciled-payments";
import { root } from '../../inmatch/api/common';
import { LandingPaymentInfo, UnresolvedGroupInfo } from "../payments-ras/common";
import { fetchAndResolve } from ".";

@define export class PaymentRaLandingSummary extends Model {
    static endpoint = restfulIO(`${root}/landing/`);

    static attributes = {
        //todo
        unresolvedPayments: type([UnresolvedGroupInfo]).dontSave.endpoint(restfulIO("./unresolved-payments")),
        unreconciledArPayments: type([LandingPaymentInfo]).dontSave.endpoint(restfulIO("./unreconciled-payments")),
        unresolvedRAs: type([UnresolvedGroupInfo]).dontSave.endpoint(restfulIO("./unresolved-ras")),
        isTodoReady: Boolean,
        //review
        autoReconciledPayments: AutoReconciledPaymentsState,
        isReviewReady: Boolean
    }

    async fetch(options?: {}) {
        Promise.all([
            fetchAndResolve(this.autoReconciledPayments)
        ]).then(() => this.isReviewReady = true)
            .catch(e => {
                console.log('fetch error PaymentRaLandingSummary -> Review');
                console.log(e);
                this.isReviewReady = true;
            });

        await Promise.all([
            this.unresolvedPayments.fetch(),
            this.unreconciledArPayments.fetch(),
            this.unresolvedRAs.fetch(),
        ]).then(() => this.isTodoReady = true)
            .catch(e => {
                console.log('fetch error PaymentRaLandingSummary -> Todo');
                console.log(e);
                this.isTodoReady = true;
            });

        return this;
    }

    get todoCount() {
        return this.totalUnresolvedPayments + this.totalUnreconciledArPayments + this.totalUnresolvedRAs;
    }

    get totalUnresolvedPayments() {
        return this.unresolvedPayments.reduce((curr: number, sum) => curr + sum.count, 0);
    }

    get totalUnreconciledArPayments() {
        return this.unreconciledArPayments.reduce((curr: number, sum) => curr + sum.count, 0);
    }

    get totalUnresolvedRAs() {
        return this.unresolvedRAs.reduce((curr: number, sum) => curr + sum.count, 0);
    }

    get totalAutoReconciledPayments() {
        return this.autoReconciledPayments.getCount();
    }

    get reviewCount() {
        return this.totalAutoReconciledPayments;
    }
}
export interface PaymentRaLandingSummary extends AttributesMixin<typeof PaymentRaLandingSummary> { }